import { useLazyContext } from "@redotech/react-util/context";
import { ConversationTagInput } from "@redotech/redo-merchant-support-app/conversation-tags/conversation-tag-input";
import { ConversationTagsContext } from "@redotech/redo-merchant-support-app/services/conversation-tags-service";
import type { AddTagAction as AddTagActionType } from "@redotech/redo-model/advanced-flow/rules/schemas";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useMemo } from "react";

export const AddTagAction = memo(function AddTagAction({
  action,
  onChange,
}: {
  action: AddTagActionType;
  onChange: (updated: AddTagActionType) => void;
}) {
  const [conversationTags] = useLazyContext(ConversationTagsContext);

  const tagNames = useMemo(() => {
    if (Array.isArray(action.tag)) {
      return new Set(action.tag);
    }
    return new Set(action.tag ? [action.tag] : []);
  }, [action.tag]);

  const tags = useMemo(
    () => conversationTags.value?.filter((tag) => tagNames.has(tag.name)) || [],
    [conversationTags.value, tagNames],
  );

  return (
    <Flex dir="column" gap="sm" w="full">
      <ConversationTagInput
        currentTags={tags}
        setCurrentTags={(tags) =>
          onChange({ ...action, tag: tags.map((tag) => tag.name) })
        }
        showAddButtonToEnterInput
      />
    </Flex>
  );
});
